export default __webpack_public_path__ + "static/media/Brooke 9781408316795.7cc3fba8.jpg";